import axios from "../api/axios.js";
import useAuth from "./useAuth.js";
// import { errorMsg } from "../helper/errorMsg.js";
import { errorMsg } from "../helpers/errorMsg.jsx";
import { jwtDecode } from "jwt-decode";

const useRefresh = () => {
	const { setAuth } = useAuth();

	const refresh = async () => {
		try {
			const response = await axios.get("/refresh", { withCredentials: true });
			console.log(response);
			if (response.status === 200) {
				setAuth((prev) => {
					console.log(prev);
					console.log(response?.data?.accessToken);
					return { ...prev, accessToken: response?.data?.accessToken };
				});

				const userData = jwtDecode(response?.data?.accessToken);
				const {
					id,
					plan,
					balance,
					profit,
					isRealMode,
					isDemoMode,
					recentInvestment,
					loss,
					email,
					withdrawalReq,
					depositAlert,
					isAdmin,
				} = userData;

				console.log(userData);
				setAuth((prev) => ({
					...prev,
					id,
					accessToken: response?.data?.accessToken,
					plan,
					balance,
					isRealMode,
					isDemoMode,
					recentInvestment,
					email,
					profit,
					loss,
					withdrawalReq,
					depositAlert,
					isAdmin,
				}));

				return response?.data?.accessToken;
			}
		} catch (error) {
			const err = errorMsg(error);
			throw new Error(err);
		}
	};

	return refresh;
};

export default useRefresh;
